module.exports = __webpack_public_path__ + "static/media/community_3.dde57642.svg";